<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-08-07 10:27:01
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-10 17:10:12
-->
<template>
  <div class="box">
    <div class="box-body" :style="{ height: height }">
      <div class="title">
        <div class="icon-title"></div>
        <div class="title-txt">基本信息</div>
      </div>
      <div class="top">
        <a-row justify="space-between">
          <a-col :span="5">
            <div class="head-left">
              <div class="head">{{userData.name && userData.name.substring(0,1)}}</div>
              <div class="user-box">
                <div class="user-name">{{userData.name}}</div>
                <div class="user-phone">{{userData.phone}}</div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div>
              <div>
                <div class="orgin">所属组织：<span :title="userData.organizationName">{{userData.organizationName}}</span></div>
                <div style="margin-top: 10px" class="orgin">
                  所属用户组：<span :title="userData.roleName">{{userData.roleName}}</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="7">
            <div style="margin-left:40px">
              <div>
                <div class="orgin">上次登录时间：<span :title="userData.loginTime">{{userData.loginTime}}</span></div>
                <div style="margin-top: 10px" class="orgin">
                  上次登录IP：<span :title="userData.loginIp">{{userData.loginIp}}</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="btn-box">
              <div @click="eidtPassword" style="margin-right: 14px" class="btn">修改密码</div>
              <div @click="lognOut" class="btn">退出登录</div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="card-box">
        <div style="width: 56.5%">
          <div class="title">
            <div class="icon-title"></div>
            <div class="title-txt">提醒关注</div>
          </div>
          <div class="text-box">
            <div class="text-one">
              <div>
                <div class="text-num">{{tiXInData.manuscriptNumber}}</div>
                <div class="text-title">待审稿件</div>
                <div v-if="codeData.indexOf('15') != -1" @click="toPath('/index/content/all_manuscripts?type=3')" class="text-btn">查看</div>
                <div v-else class="text-btn">查看</div>
              </div>
            </div>
            <div class="text-one">
              <div>
                <div class="text-num">{{tiXInData.applyOpenNumber}}</div>
                <div  class="text-title">未处理依申请</div>
                <div v-if="codeData.indexOf('302') != -1" @click="toPath('/index/applicationlist')" class="text-btn">查看</div>
                <div v-else class="text-btn">查看</div>
              </div>
            </div>
            <div class="text-one">
              <div>
                <div class="text-num">{{tiXInData.notSubmitNumber}}</div>
                <div   class="text-title">未报送稿件</div>
                <div v-if="codeData.indexOf('347') != -1" @click="toPath('/index/content/manuscript_submitted')" class="text-btn">查看</div>
                <div v-else class="text-btn">查看</div>
              </div>
            </div>
            <div class="text-one">
              <div>
                <div class="text-num">{{tiXInData.notAdoptNumber}}</div>
                <div class="text-title">未采纳稿件</div>
                <div v-if="codeData.indexOf('363') != -1" @click="toPath('/index/content/manuscript_adopt')" class="text-btn">查看</div>
                <div v-else class="text-btn">查看</div>
              </div>
            </div>
            <div class="text-one">
              <div>
                <div class="text-num">{{tiXInData.sendMeNumber}}</div>
                <div class="text-title">未处理约稿</div>
                <div v-if="codeData.indexOf('383') != -1" @click="toPath('/index/content/platform_solicitation')" class="text-btn">查看</div>
                <div v-else  class="text-btn">查看</div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 43.5%">
          <div class="jianche-box">
              <div style="margin-bottom:0px" class="title">
                <div class="icon-title"></div>
                <div class="title-txt">指标监测</div>
              </div>
              <div class="genxin-time">更新于 {{jianCheData.updateTime}}</div>
          </div>
          <div class="text-box">
            <div class="text-one">
              <div>
                <div class="text-num-two" v-if="jianCheData.siteUsabilityStatus==0">合格</div>
                <div style="color:#F56C6C" class="text-num-two" v-if="jianCheData.siteUsabilityStatus==1">不合格</div>
                <div class="text-title">站点可用性</div>
                <div v-if="codeData.indexOf('321') != -1" @click="toPath('/index/statistics/test_date')" class="text-btn">查看</div>
                <div v-else  class="text-btn">查看</div>
              </div>
            </div>
            <div class="text-one">
              <div>
                <div style="color:rgba(103, 194, 58, 1);" v-if="jianCheData.indexMonitorStatus==0" class="text-num-two">合格</div>
                <div style="color:#e6a23c" v-if="jianCheData.indexMonitorStatus==1" class="text-num-two">告警</div>
                <div style="color:#F56C6C" v-if="jianCheData.indexMonitorStatus==2" class="text-num-two">不合格</div>
                <div class="text-title">首页不更新</div>
                <div  v-if="codeData.indexOf('323') != -1" @click="toPath('/index/statistics/test_date?activeName=second')" class="text-btn">查看</div>
                <div  v-else  class="text-btn">查看</div>
              
              </div>
            </div>
            <div class="text-one">
              <div>
                <div style="color:rgba(103, 194, 58, 1);"  v-if="jianCheData.columnMonitorStatus==0" class="text-num-three">合格</div>
                <div style="color:#e6a23c" v-if="jianCheData.columnMonitorStatus==1" class="text-num-three">告警</div>
                <div style="color:#F56C6C" v-if="jianCheData.columnMonitorStatus==2" class="text-num-three">不合格</div>
                <div class="text-title">栏目不更新</div>
                <div v-if="codeData.indexOf('328') != -1" @click="toPath('/index/statistics/test_date?activeName=third')"  class="text-btn">查看</div>
                <div v-else  class="text-btn">查看</div>
              </div>
            </div>
            <div style="margin-right: 0px" class="text-one">
              <div>
                <div class="text-num-four">{{jianCheData.errorProportion}}</div>
                <div class="text-title">错链占比</div>
                <div v-if="codeData.indexOf('333') != -1" @click="toPath('/index/statistics/test_date?activeName=fourth')" class="text-btn">查看</div>
                <div v-else  class="text-btn">查看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="three-top">
        <div style="margin-top: 24px" class="title">
          <div class="icon-title"></div>
          <div class="title-txt">站点稿件更新情况</div>
        </div>
        <div class="time">
          <div
            @click="timeType(1)"
            :class="timeNum == 1 ? 'time-type' : ''"
            class="qi-day"
          >
            近7日
          </div>
          <div
            @click="timeType(2)"
            :class="timeNum == 2 ? 'time-type' : ''"
            class="three-day"
          >
            近30日
          </div>
          <el-date-picker
            v-model="timeValue"
            type="daterange"
            @change="selectTime"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="gen-xin">
        <div class="gen-xin-left">
          <div class="cont-time">
           <span v-if="timeNum==1 || timeNum==2"> 近{{ timeNum == 1 ? "7" : timeNum == 2?"30":'' }}日发布稿件总量统计</span>
           <span v-if="timeNum==3">{{startTimeNum}} 至 {{endTimeNum}}发布稿件总量统计</span>
          </div>
          <div class="cont">
            <div class="cont-name">
              全站发稿总量 
              <el-popover
                 placement="top-start"
                width="300"
                trigger="hover"
                :content="`${siteName}近7日发稿总量`">
                 <i style="cursor: pointer;" slot="reference" class="ri-error-warning-line"></i>
              </el-popover>
             
            </div>
            <div class="cont-num">{{gaoJianData.sitePushNumber}}</div>
          </div>
          <div class="cont">
            <div class="cont-name">
              组织发稿总量 
              <el-popover
                 placement="top-start"
                width="300"
                trigger="hover"
                :content="`您所在${userData.organizationName}下所有管理人员近7日发稿总量`">
                 <i style="cursor: pointer;" slot="reference" class="ri-error-warning-line"></i>
              </el-popover>
            </div>
            <div class="cont-num">{{gaoJianData.organPushNumber}}</div>
          </div>
          <div class="cont">
            <div class="cont-name">
              个人发稿总量 
              <el-popover
                 placement="top-start"
                width="250"
                trigger="hover"
                :content="`${userData.name}管理员近7日发稿总量`">
                 <i style="cursor: pointer;" slot="reference" class="ri-error-warning-line"></i>
              </el-popover>
            </div>
            <div class="cont-num">{{gaoJianData.personPushNumber}}</div>
          </div>
        </div>
        <div class="gen-xin-left">
          <div class="cont-time">
            <span v-if="timeNum==1 || timeNum==2"> 近{{ timeNum == 1 ? "7" : timeNum == 2?"30":'' }}日绩效考核统计</span>
            <span v-if="timeNum==3">{{startTimeNum}} 至 {{endTimeNum}}绩效考核统计</span>
          </div>
          <div class="cont">
            <div class="cont-name">
              {{ formData.typeName }}
              <el-popover
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  :content="formData.title">
                <i style="cursor: pointer;" slot="reference" class="ri-error-warning-line"></i>
              </el-popover>

            </div>
            <div class="cont-num">{{formData.rank}}</div>
          </div>
          <div style="display: flex;flex-direction: column;margin-top: 10px;border-radius: 4px;justify-content: space-around;background-color: rgba(247, 249, 250, 1);border: 1px solid rgba(228, 231, 237, 1);">
            <div class="ranking">
              <div class="item">
                <div class="cont-num">{{formData.loginMark}}</div>
                登录得分
              </div>
              <div class="item">
                <div class="cont-num">{{formData.reportsMark}}</div>
                发稿得分
              </div>
              <div class="item">
                <div class="cont-num">{{formData.adoptMark}}</div>
                报送得分
              </div>
            </div>
            <div class="ranking_tips">{{formData.content}}</div>
          </div>
        </div>
        <div class="gen-xin-right">
          <div class="cont-time">
             <span v-if="timeNum==1 || timeNum==2">近{{ timeNum == 1 ? "7" : timeNum == 2?"30":'' }}日发布稿件趋势</span>
             <span v-if="timeNum==3">{{startTimeNum}} 至 {{endTimeNum}}发布稿件趋势</span>
          </div>
          <div id="site-chart" class="gender-chart"></div>
        </div>
      </div>
      <div class="fen-xi">
        <div class="fen-xi-box">
          <div>
            <div class="title">
              <div class="icon-title"></div>
              <div class="title-txt">词云分析</div>
            </div>
            <div class="fen-xi-left">
              <div id="word-cloud" class="word-cloud"></div>
            </div>
          </div>
          <div class="fen-xi-right">
            <div class="title">
              <div class="icon-title"></div>
              <div class="title-txt">智能问答未知问题</div>
            </div>
            <a-table
              :pagination="false"
              :columns="columns"
              :data-source="dataSource"
            >
            </a-table>
          </div>
        </div>
      </div>
      <div class="bottom-box">
            <div class="jisu">
                <div class="jisu-text"> <span>版权所有：甘孜藏族自治州人民政府办公室</span></div>
                <div class="jisu-text"><span>技术支持：康定市相知莫问信息科技有限公司</span></div>
            </div>
            <div class="fuwu-phone">服务热线：<a>156 8180 8062</a></div>
      </div>
    </div>
    <div class="left">
      <div class="title">
        <div class="icon-title"></div>
        <div class="title-txt">快捷导航</div>
      </div>
      <div class="right-nav">
        <div @click="codeData.indexOf('10') != -1?toPath('/index/content/manuscripts'):''" class="right-one">
          <div>
            <i class="ri-add-box-fill"></i>
            <div   class="right-text">创作稿件</div>
          </div>
        </div>
        <div @click="codeData.indexOf('14') != -1?toPath('/index/content/all_manuscripts'):''" class="right-one">
          <div>
            <i class="ri-account-pin-circle-fill"></i>
            <div  class="right-text">我的稿件</div>
          </div>
        </div>
        <div @click="codeData.indexOf('09') != -1?toPath('/index/content/column_manuscript'):''" class="right-one">
          <div>
            <i class="ri-bar-chart-horizontal-fill"></i>
            <div  class="right-text">栏目稿件</div>
          </div>
        </div>
        <div @click="codeData.indexOf('346') != -1?toPath('/index/content/manuscript_submitted'):''" class="right-one">
          <div>
            <i class="ri-send-plane-fill"></i>
            <div  class="right-text">稿件报送</div>
          </div>
        </div>
        <div @click="codeData.indexOf('361') != -1?toPath('/index/content/manuscript_adopt'):''" style="margin-right: 0px" class="right-one">
          <div>
            <i class="ri-checkbox-circle-fill"></i>
            <div class="right-text">稿件采纳</div>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px" class="right-nav">
        <div  @click="codeData.indexOf('41') != -1?toPath('/index/interaction/solicitation_survey'):''" class="right-one">
          <div>
            <i class="ri-mail-star-fill"></i>
            <div class="right-text">意见征集</div>
          </div>
        </div>
        <div  @click="codeData.indexOf('292') != -1?toPath('/index/questionnaire'):''" class="right-one">
          <div>
            <i class="ri-file-edit-fill"></i>
            <div class="right-text">问卷调查</div>
          </div>
        </div>
        <div  @click="codeData.indexOf('302') != -1?toPath('/index/applicationlist'):''" class="right-one">
          <div>
            <i class="ri-file-list-3-fill"></i>
            <div class="right-text">申请清单</div>
          </div>
        </div>
        <div  @click="codeData.indexOf('425') != -1?toPath('/index/reporting'):''" class="right-one">
          <div>
            <i class="ri-git-repository-fill"></i>
            <div class="right-text">申请报备</div>
          </div>
        </div>
        <div @click="codeData.indexOf('320') != -1?toPath('/index/statistics/test_date'):''" style="margin-right: 0px" class="right-one">
          <div>
            <i class="ri-file-chart-fill"></i>
            <div class="right-text">指标监测</div>
          </div>
        </div>
      </div>
      <div style="margin-top: 24px; margin-bottom: 0px" class="title">
        <div class="icon-title"></div>
        <div class="title-txt">站点动态</div>
      </div>
      <div>
        <div class="dong-tai" :style="{ height: `${heightTwo/2}px` }">
          <div class="dong-tai-item" v-for="item in siteDynamics">
            <div class="fabu-box">
              <div
                v-if="item.state == 4"
                class="fabu"
              >
                稿件发布
              </div>
              <div  v-if="item.state == 5" class="xiaxian">稿件下线</div>

              <div
                v-if="item.state == 4"
                class="fabu-txt"
              >
                <a @click="towebsite(item)"
                  ><span :title="item.title">{{ item.title }}</span></a
                >
              </div>
              <div v-if="item.state == 5" class="fabu-txt">{{ item.title }}</div>
            </div>
            <div class="fabu-name">
              <div class="biaji">
                <span style="margin-right: 20px"
                  >编辑: {{ item.createName }}</span
                ><span
                  >{{
                    item.state == 0
                      ? "草稿"
                      : item.state == 1
                      ? "审核中"
                      : item.state == 2
                      ? "审核通过"
                      : item.state == 3
                      ? "审核失败"
                      : item.state == 4
                      ? "发布"
                      : "下线"
                  }}: {{ item.name }}</span
                >
              </div>
              <div class="bianji-time">
                时间<span :title="item.time"> {{ item.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 24px; margin-bottom: 20px" class="title">
        <div class="icon-title"></div>
        <div class="title-txt">平台更新日志</div>
      </div>
      <div class="dong-box" :style="{ height: `${(heightTwo/2)-100}px` }">
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(item, index) in platformDynamics"
            :key="index"
          >
            <div class="right-time-pi">{{ index }}</div>
            <div>
              <div v-for="(itemTwo, indexTwo) in item" class="pi-txt">
                {{ indexTwo + 1 }}.{{ itemTwo.content }}
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <el-dialog
      :title="'修改密码'"
      :visible.sync="dialogVisible"
      width="535px"
      top="17%"
       class="demo-ruleForm"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
     <div class="title-box">
            <i class="el-icon-info icon-title"></i>
            <div>初次登录平台，请修改密码，并牢记密码</div>
          </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
       <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="ruleForm.oldPassword"
            placeholder="请输入原密码"
          >
           <i class="ri-eye-fill" slot="suffix"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="ruleForm.newPassword"
            maxlength="15"
            placeholder="新密码不少于12位最多15位，应包含字母、数字及符号 ~!@#$%^&* "
          >
              <i class="ri-eye-fill" slot="suffix"></i>
          </el-input>
        </el-form-item>
       <el-form-item label="确认密码" prop="quePassword">
          <el-input
           maxlength="15"
            v-model="ruleForm.quePassword"
            placeholder="请再次输入新密码"
          >
           <i class="ri-eye-fill" slot="suffix"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium"  @click="cancellation">取 消</el-button>
        <el-button size="medium" v-repeatClick :loading="loadingBtn" type="primary" @click="addLinksFn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import echarts from "echarts";
import {
  wordCloudAnalysis,
  selectJournalList,
  selectListData,
  countManuscriptTrends,
  countSiteManuscriptNumber,
  findListPage,
  reminderFollowNumber,
  selectManById,
  workbench, orgRanking
} from "./work_bench";
import {loginOut,updatePassword} from '@/api/common.js';
import wordcloud from "echarts-wordcloud";
import {pass} from '@/utils/reg.js';
import coententTable from "@/components/coentent_table.vue";
import { removeWatermark } from "@/utils/waterMark";
import router from "../../router";
export default {
  data() {
    return {
      timeValue: "",
      timeNum: 1,
      myChart: "",
      startTime: "",
      endTime: "",
      valueSite: "",
      reverse:false,
      myChart3: "",
      loadingBtn:false,
      height: "",
      heightTwo:"",
      siteName:sessionStorage.getItem('siteName'),
      heightThree:"",
      columns: [
        {
          title: "问题",
          dataIndex: "unknownQuestion",
          ellipsis: true,
        },
        {
          title: "提问时间",
          dataIndex: "quizTime",
          width: 200,
          ellipsis: true,
        },
      ],
      dataSource: [],
      siteDynamics: [],
      platformDynamics: [],
      gaoJianData:{},
      tiXInData:{},
      userData:{},
        ruleForm:{
        oldPassword:"",
        newPassword:"",
        quePassword:"",
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            validator: pass,trigger: "blur",
          } 
        ],
        quePassword: [{ required: true, message: "请输入确认密码", trigger: "blur" }],
      },
      dialogVisible:false,
      jianCheData:{},
      codeData:[],
      startTimeNum:'',
      endTimeNum:'',
      maskImage:'',
      formData:{}
    };
  },
  mounted() {
    this.valueSite = sessionStorage.getItem("siteId");
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    let startTime =
      new Date(new Date().toLocaleDateString()).getTime() -
      7 * 24 * 3600 * 1000;
    let endTime = new Date(new Date().toLocaleDateString()).getTime();
    this.startTime = this.farmatDate(startTime, "-");
    this.endTime = this.farmatDateTwo(endTime, "-");
    this.endTime = this.endTime + " " + "23:59:59";
    this.height = document.documentElement.clientHeight + "px";
    this.maskImage = new Image();
     this.maskImage.src = require('../../assets/images/yuan.png');
    this.$nextTick(()=>{
        if(this.valueSite){
           this.getSiteQuShi();
          this.getCloud();
          this.getGaoJian();
          this.getSiteDynamics();
          this.getDynamicData();
          this.getWeiZhi();
          this.getTiXin();
          this.getUser();
          this.getJianChe();
          this.getOrgRanking();
        }
    })
  },
  components: {
    coententTable,
  },
  methods: {
    getOrgRanking(){
      orgRanking({
        startTime:this.startTime,
        endTime:this.endTime
      }).then(res=>{
        this.formData = res.data;
      })
    },
    selectTime(time) {
      this.timeNum = 3;
      if (time) {
        this.startTime = this.farmatDate(
          new Date(time[0].toString()).getTime(),
          "-"
        );
        this.startTimeNum = this.farmatDateTwo(
          new Date(time[0].toString()).getTime(),
          "-"
        );
        this.endTimeNum = this.farmatDateTwo(
          new Date(time[1].toString()).getTime(),
          "-"
        );
        this.endTime = this.farmatDateTwo(
          new Date(time[1].toString()).getTime(),
          "-"
        );
        this.endTime = this.endTime + " " + "23:59:59";
      }else{
        this.timeType(1);
      }
      this.getSiteQuShi();
      this.getGaoJian();
      this.getOrgRanking();
    },
    timeType(type) {
      this.timeNum = type;
      if (type == 1) {
        let startTime =
          new Date(new Date().toLocaleDateString()).getTime() -
          7 * 24 * 3600 * 1000;
        let endTime = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = this.farmatDate(startTime, "-");
        this.endTime = this.farmatDateTwo(endTime, "-");
        this.endTime = this.endTime + ' ' + '23:59:59'
      } else {
        let startTime =
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000;
        let endTime = new Date(new Date().toLocaleDateString()).getTime();
        this.startTime = this.farmatDate(startTime, "-");
        this.endTime = this.farmatDateTwo(endTime, "-");
        this.endTime = this.endTime + ' ' + '23:59:59'
      }
      this.getSiteQuShi();
      this.getGaoJian();
      this.getOrgRanking();
    },
    getGaoJian(){
      countSiteManuscriptNumber({
           siteId: this.valueSite,
          startTime: this.startTime,
          endTime: this.endTime,
      }).then((res)=>{
            if(res.code == 0){
                this.gaoJianData = res.data;
            }
        })
    },
     eidtPassword(){
       this.dialogVisible = true;
    },
    toPath(url){
       if(url == '/index/content/manuscripts'){
           let routeData = this.$router.resolve({ path: "/index/content/manuscripts" });
            window.open(routeData.href, '_blank');
      }else{
        this.$router.push(url).catch(()=>{});
      }
    },
     cancellation(){
        this.$refs.ruleForm.resetFields();
        this.dialogVisible = false;
    },
    lognOut(){
        loginOut({
          id:JSON.parse(sessionStorage.getItem('userInfo')).id,
        }).then((res)=>{
            if(res.code == 0){
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userInfo');
                sessionStorage.removeItem('menuData');
                sessionStorage.removeItem('siteId');
                sessionStorage.removeItem('siteName');
                removeWatermark();
                router.push("/login");
            }
        })
    },
    towebsite(item){
        window.open(item.url)
    },
     addLinksFn(){
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        this.loadingBtn = true;
         this.$refs.ruleForm.validate((valid) => {
            if(valid){
              if(this.ruleForm.newPassword != this.ruleForm.quePassword){
                    message.error('新密码与确认密码不一致');
                    this.loadingBtn = false;
                    return;
                }else{
                    updatePassword({...this.ruleForm,id:userInfo.id}).then((res)=>{
                        if(res.code == 0){
                            this.$refs.ruleForm.resetFields();
                            this.dialogVisible = false;
                            this.lognOut()
                        }
                         this.loadingBtn = false;
                    })
                }
            }else{
              this.loadingBtn = false;
            }
         })
        
    },
    getTiXin(){
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      reminderFollowNumber({
        siteId:this.valueSite,
        organizationId:userInfo.organizationId,
        mainOrganizations:userInfo.mainOrganizations,
      }).then((res)=>{
          if(res.code == 0){
              this.tiXInData = res.data;
          }
      })
    },
    handleSizeChange() {},
    getSiteDynamics() {
      selectJournalList({
        id: this.valueSite,
      }).then((res) => {
        if (res.code == 0) {
          this.siteDynamics = res.data;
          this.heightTwo = document.documentElement.clientHeight - 334;
          window.onresize = () => {
            return (() => {
              this.myChart.resize();
              this.myChart3.resize();
              this.heightTwo = document.documentElement.clientHeight - 334;
              this.height = document.documentElement.clientHeight + "px";
            })();
          };
        }
      });
    },
    onShowSizeChange() {},
    getUser(){
      selectManById({
        id:JSON.parse(sessionStorage.getItem('userInfo')).id,
      }).then((res)=>{
          if(res.code == 0){
              this.userData = res.data;
          }
      })
    },
     handleClose(){
        this.$refs.ruleForm.resetFields();
        this.dialogVisible = false;
    },
    getSiteQuShi() {
     
      countManuscriptTrends({
        siteId: this.valueSite,
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res)=>{
          if(res.code == 0){
            let dataOne = [];
            let dataTwo = [];
            let dataThree = [];
            let dataTime = [];
            for (let index = 0; index < res.data.length; index++) {
              const element = res.data[index];
              dataTime.push(element.time)
              dataOne.push(element.sitePushNumber)
              dataTwo.push(element.organPushNumber)
              dataThree.push(element.personPushNumber)
            }
               let option = {
                  tooltip: {
                    trigger: "axis",
                    axisPointer: {
                      type: "cross",
                      label: {
                        backgroundColor: "#6a7985",
                      },
                    },
                  },
                  dataZoom: [{
                    type: 'slider',
                    show: true, //flase直接隐藏图形
                    xAxisIndex: [0],
                    left: '10%', //滚动条靠左侧的百分比
                    bottom: -10,
                    start: 0,//滚动条的起始位置
                    end: 50//滚动条的截止位置（按比例分割你的柱状图x轴长度）
                  }],
                  grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "15%",
                    top: "10%",
                    containLabel: true,
                  },
                  xAxis: {
                    data: dataTime,
                  },
                  yAxis: {},
                  series: [
                    {
                      data: dataOne,
                      type: "line",
                      name: '全站发稿总量',
                      itemStyle: {
                        normal: {
                          color: "#68bbc4",
                          lineStyle: {
                            color: "#68bbc4"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#68bbc4",
                        opacity: 0.5,
                      },
                    },
                    {
                      data: dataTwo,
                      type: "line",
                      name: '组织发稿总量',
                      itemStyle: {
                        normal: {
                          color: "#558aec",
                          lineStyle: {
                            color: "#558aec"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#558aec",
                        opacity: 0.5,
                      },
                    },
                    {
                      data: dataThree,
                      type: "line",
                      name: '个人发稿总量',
                      itemStyle: {
                        normal: {
                          color: "#58a55c",
                          lineStyle: {
                            color: "#58a55c"
                          }
                        }
                      },
                      areaStyle: {
                        color: "#58a55c",
                        opacity: 0.5,
                      },
                    },
                  ],
                };
                 var chartDom = document.getElementById("site-chart");
                this.myChart = echarts.init(chartDom);
                option && this.myChart.setOption(option);
          }
      })
     
    },
    farmatDateTwo(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getCloud() {
      wordCloudAnalysis({
          siteId: this.valueSite,
          startTime: this.startTime,
          endTime: this.endTime,
      }).then((res) => {
        if (res.code == 0) {
          let array = [];
          res.data.forEach((element) => {
            array.push({
              value: element.number,
              name: element.text,
            });
          });
          let wordOption = {
            series: [{
                      type: 'wordCloud',
                      shape: 'circle',
                      rotationRange: [0,0],
                      sizeRange: [12, 50],
                      gridSize: 10,
                      width: "120%",
                      height: "120%",
                      maskImage: this.maskImage,
                      textStyle: {
                      normal: {
                            fontFamily: 'sans-serif',
                                color: function () {
                                    return 'rgb(' + [
                                        Math.round(Math.random() * 160),
                                        Math.round(Math.random() * 160),
                                        Math.round(Math.random() * 160)
                                    ].join(',') + ')';
                                }
                            },
                            emphasis: {
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        },
                        data:array,
              }]
          };
          var chartDom3 = document.getElementById("word-cloud");
          this.myChart3 = echarts.init(chartDom3);
          wordOption && this.myChart3.setOption(wordOption);
        }
      });
    },
    getDynamicData() {
      selectListData({}).then((res) => {
        if (res.code == 0) {
          this.platformDynamics = res.data;
        }
      });
    },
    getWeiZhi(){
      findListPage({
        current:1,
        size:7,
        siteId:this.valueSite,
      }).then((res)=>{
          if(res.code == 0){
              this.dataSource = res.data.records;
          }
      })
    },
    getJianChe(){
      workbench({
         siteId:this.valueSite,
      }).then((res)=>{
          if(res.code == 0){
              this.jianCheData = res.data;
          }
      })
    }
  },
};
</script>
<style lang="less" scoped>
.box {
  display: flex;
  background: #f0f2f5;
  overflow-y: auto;
}
.box-body {
  padding: 24px;
  width: 70.6%;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  overflow-y: auto;
  position: relative;
   padding-bottom: 80px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 5px;
    .icon-title {
      width: 4px;
      height: 18px;
      border-radius: 2px;
      background-color: rgba(23, 109, 230, 1);
    }
    .title-txt {
      color: #303133;
      font-size: 16px;
      font-family: HarmonyOS_Sans_SC-regular;
      margin-left: 10px;
      font-weight: 600;
    }
  }
  .top {
    height: 120px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(245, 247, 250, 1);
    border: 1px solid rgba(228, 231, 237, 1);
    display: flex;
    align-items: center;
    padding: 30px;
    justify-content: space-between;
    margin-bottom: 24px;
    .head-left {
      display: flex;
      align-items: center;
      margin-right: 10px;
    }
    .head {
      width: 60px;
      height: 60px;
      background: linear-gradient(
        135deg,
        rgba(70, 112, 244, 1) 3%,
        rgba(136, 163, 249, 1) 103.6%
      );
      color: rgba(255, 255, 255, 1);
      font-size: 26px;
      text-align: center;
      font-family: Roboto;
      line-height: 60px;
      border-radius: 50%;
      margin-right: 14px;
    }
    .user-box{
      flex: 1;
       overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
    .user-name {
      color: rgba(48, 49, 51, 1);
      font-size: 20px;
      font-weight: 600;
      font-family: HarmonyOS_Sans_SC-bold;
    }
    .user-phone {
      color: rgba(102, 111, 128, 1);
      font-size: 16px;
      font-family: HarmonyOS_Sans_SC-regular;
      margin-top: 10px;
       overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
    .btn-box {
      display: flex;
      justify-content: flex-end;
      .btn {
        width: 96px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        background-color: rgba(240, 246, 255, 1);
        text-align: center;
        border: 1px solid rgba(23, 109, 230, 1);
        color: rgba(23, 109, 230, 1);
        font-size: 14px;
        font-family: HarmonyOS_Sans_SC-regular;
        cursor: pointer;
      }
    }
    .orgin {
      color: rgba(102, 111, 128, 1);
      font-size: 14px;
      text-align: left;
      font-family: HarmonyOS_Sans_SC-regular;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      width: 100%;
    }
  }
  .text-box {
    display: flex;
    width: 100%;
    .text-one {
      max-width: 123px;
      flex: 1;
      height: 126px;
      line-height: 24px;
      border-radius: 4px;
      background-color: rgba(247, 249, 250, 1);
      text-align: center;
      border: 1px solid rgba(228, 231, 237, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      &:hover {
        border-radius: 4px;
        background-color: rgba(247, 249, 250, 1);
        box-shadow: 0px 2px 6px 0px #e4e7ed;
        border: 1px solid rgba(228, 231, 237, 1);
      }
      .text-num {
        color: rgba(51, 51, 51, 1);
        font-size: 30px;
        text-align: center;
        font-family: HarmonyOS_Sans_SC-bold;
        font-weight: 600;
      }
      .text-title {
        color: rgba(102, 111, 128, 1);
        font-size: 14px;
        text-align: center;
        font-family: HarmonyOS_Sans_SC-regular;
        margin-top: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .text-btn {
        width: 46px;
        height: 22px;
        border-radius: 15px;
        background-color: rgba(255, 255, 255, 1);
        color: rgba(102, 111, 128, 1);
        font-size: 12px;
        text-align: center;
        font-family: Roboto;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(211, 212, 214, 1);
        margin-top: 16px;
        cursor: pointer;
      }
    }
  }
  .card-box {
    display: flex;
    justify-content: space-between;
    .text-num-two {
      color: rgba(103, 194, 58, 1);
      font-size: 24px;
      text-align: center;
      font-family: HarmonyOS_Sans_SC-bold;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .text-num-three {
      color: #f56c6c;
      font-size: 24px;
      text-align: center;
      font-family: HarmonyOS_Sans_SC-bold;
      font-weight: 600;
    }
    .text-num-four {
      color: rgba(51, 51, 51, 1);
      font-size: 24px;
      text-align: center;
      font-family: HarmonyOS_Sans_SC-bold;
      font-weight: 600;
    }
  }
  /deep/ .ant-row {
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  .time {
    display: flex;
    align-items: center;
  }
  .three-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .qi-day,
  .three-day {
    line-height: 24px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 1);
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: center;
    font-family: Roboto;
    border: 1px solid rgba(220, 223, 230, 1);
    width: 56px;
    height: 24px;
    margin-right: 14px;
    cursor: pointer;
  }
  /deep/ .el-input__inner {
    height: 24px;
    line-height: 24px;
  }
  /deep/ .el-date-editor .el-range__icon {
    line-height: 18px;
  }
  /deep/ .el-date-editor .el-range-separator {
    line-height: 18px;
    padding: 0px;
  }
  .time-type {
    border: 1px solid rgba(23, 109, 230, 1) !important;
    color: rgba(23, 109, 230, 1) !important;
  }
  .gen-xin {
    display: flex;
    justify-content: space-between;
    .gen-xin-left {
      width: 386px;
      height: 236px;
      line-height: 20px;
      border-radius: 4px;
      padding: 16px;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(228, 231, 237, 1);
      margin-right: 20px;
      .ranking_tips{
        margin-bottom: 10px;
        text-align: center;
      }
      .ranking{
        display: flex;
        justify-content: space-around;
        padding: 20px 0 14px;
        >.item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .cont-num {
            color: rgba(51, 51, 51, 1);
            font-size: 24px;
            text-align: right;
            font-family: HarmonyOS_Sans_SC-bold;
            font-weight: 600;
            margin-bottom: 6px;
          }
        }
      }
      .cont {
        height: 52px;
        line-height: 20px;
        border-radius: 4px;
        background-color: rgba(247, 249, 250, 1);
        color: rgba(16, 16, 16, 1);
        font-size: 14px;
        align-items: center;
        font-family: Roboto;
        border: 1px solid rgba(228, 231, 237, 1);
        display: flex;
        justify-content: space-between;
        padding-left: 14px;
        padding-right: 30px;
        margin-top: 10px;
        .cont-name {
          color: rgba(16, 16, 16, 1);
          font-size: 14px;
          font-family: HarmonyOS_Sans_SC-regular;
        }
        .cont-num {
          color: rgba(51, 51, 51, 1);
          font-size: 24px;
          text-align: right;
          font-family: HarmonyOS_Sans_SC-bold;
          font-weight: 600;
        }
      }
      .cont-time {
        color: rgba(102, 111, 128, 1);
        font-size: 16px;
        text-align: left;
        font-family: HarmonyOS_Sans_SC-regular;
        font-weight: 600;
      }
    }
    .gen-xin-right {
      flex: 1;
      height: 236px;
      line-height: 20px;
      border-radius: 4px;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(228, 231, 237, 1);
      padding: 16px;
      .cont-time {
        color: rgba(102, 111, 128, 1);
        font-size: 16px;
        text-align: left;
        font-family: HarmonyOS_Sans_SC-regular;
        font-weight: 600;
      }
      .gender-chart {
        width: 100%;
        height: 192px;
      }
    }
  }
  .fen-xi-title {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  }
  .fen-xi-box {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  }
  .fen-xi-left {
    width: 386px;
    height: 388px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 1);
    text-align: center;
    border: 1px solid rgba(228, 231, 237, 1);
    .word-cloud {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .fen-xi-right {
    flex: 1;
    min-height: 384px;
    background: #fff;
    /deep/ .ant-table-thead > tr > th {
      background: #f5f7fa;
      font-weight: 600;
      font-size: 16px;
    }
    /deep/ .ant-table {
      border: solid 1px #e8e8e8;
    }
    margin-left: 20px;
  }
}
.fabu-box {
  display: flex;
  .fabu {
    height: 22px;
    border-radius: 2px;
    background-color: rgba(242, 249, 236, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-family: Roboto;
    border: 1px solid rgba(207, 232, 189, 1);
    margin-right: 20px;
    color: rgba(131, 194, 86, 1);
    font-size: 12px;
    text-align: left;
    font-family: Roboto-regular;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .xiaxian {
    height: 22px;
    border-radius: 2px;
    background-color: rgba(244, 244, 245, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    text-align: center;
    font-family: Roboto;
    border: 1px solid rgba(211, 212, 214, 1);
    color: rgba(145, 147, 153, 1);
    font-size: 12px;
    text-align: left;
    font-family: Roboto-regular;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    margin-right: 20px;
  }
}
.fabu-name {
  display: flex;
  margin-top: 14px;
}
.dong-tai {
  overflow: auto;
}
.bianji-time {
  margin-left: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  text-align: left;
}
.fabu-txt {
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  font-family: Roboto-regular;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  text-align: left;
}
/deep/ .ri-error-warning-line:before {
  font-size: 18px;
  color: rgba(96, 98, 102, 1);
}
.left {
  width: 29.4%;
  max-width: 528px;
  height: 1203px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  border: 1px solid rgba(229, 229, 229, 1);
  margin-left: 20px;
  min-width: 320px;
  padding: 24px;
  .right-one {
    max-width: 88px;
    flex: 1;
    height: 84px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(247, 249, 250, 1);
    text-align: center;
    border: 1px solid rgba(228, 231, 237, 1);
    align-items: center;
    display: flex;
    justify-content: center;
    cursor: pointer;
    margin-right: 10px;
    &:hover {
      box-shadow: 0px 2px 6px 0px #e4e7ed;
      color: rgba(24, 109, 230, 1);
      .right-text {
        color: rgba(24, 109, 230, 1);
      }
    }
    /deep/ .ri-add-box-fill:before {
      font-size: 30px;
      margin-bottom: 4px;
    }
    .right-text {
      color: rgba(102, 111, 128, 1);
      font-size: 14px;
      text-align: center;
      font-family: HarmonyOS_Sans_SC-regular;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .right-nav {
    display: flex;
    justify-content: space-between;
  }
  /deep/ .ri-account-pin-circle-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-bar-chart-horizontal-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-send-plane-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-checkbox-circle-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-mail-star-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-file-edit-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-file-list-3-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-git-repository-fill:before {
    font-size: 30px;
  }
  /deep/ .ri-file-chart-fill:before {
    font-size: 30px;
  }
}
.dong-tai-item {
  border-bottom: 1px solid rgba(245, 245, 245, 1);
  padding: 16px 0px;
}
.dong-box {
  overflow: auto;
  padding-bottom: 70px;
}
/deep/ .ant-timeline-item-head-blue {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-color: rgba(24, 144, 255, 0.2);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
}

/deep/ .el-timeline-item__icon {
  color: #fff;
  font-size: 18px;
  background: #fff;
}
/deep/ .el-timeline-item__node--normal {
  width: 12px;
  height: 12px;
  line-height: 20px;
  background-color: rgba(24, 144, 255, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  box-shadow: 0px 0px 6px rgba(24, 144, 255);
}
.right-time-pi {
  color: rgba(24, 144, 255, 1);
  font-size: 16px;
  text-align: left;
  font-family: Roboto-bold;
  font-weight: 600;
  margin-bottom: 12px;
}
.pi-txt {
  margin-bottom: 12px;
  text-align: left;
}
/deep/ .el-timeline {
  padding: 0;
  padding-left: 12px;
  margin-top: 6px;
}
.bottom-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(245, 247, 250, 1);
  width:100%;
  margin-top: 24px;
  padding: 0 20px;
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  font-family: Roboto-regular;
  .jisu{
    display: flex;
    .jisu-text{
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 30px;
    }
  }
  .fuwu-phone{
       text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
}

/deep/ .ant-table-thead > tr > th{
  padding: 13px 16px;
}
/deep/ .ant-table-tbody > tr > td{
padding: 13px 16px;
}
/deep/ .el-date-editor .el-range__close-icon{
  line-height: 18px;
}
.jianche-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.genxin-time{
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  text-align: right;
  font-family: HarmonyOS_Sans_SC-regular;
}
@media screen and (max-width: 1440px) {
  .right-text {
    width: 40px !important;
  }
}
/deep/ .el-dialog__title{
  font-weight: 600;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 20px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
/deep/ .el-dialog__body{
  padding-top: 10px;
  padding-bottom: 0px;
}
/deep/ .el-button--primary {
  background: #176de6;
}
/deep/ .ri-eye-fill:before{
   color: #97A1AF;
}
</style>